import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React,{useState} from 'react'
import { faCaretUp,faCaretDown ,faStar} from '@fortawesome/free-solid-svg-icons'

export default function EmployeeRating(props) {
    const [order,setOrder]=useState(true)
    const check= props.data && props.data.length>0//return true or false
        //getting top rating
;
    const getTopRated = check?props.data.map((item,index)=>{
        return(
            <li className='order-item' key={index}>
                <div className="right">
                    <img src={item.employee.profile_pic} />
                    <span>{item.employee.username}</span>
                </div>
                
                <span className='employee-rating'>
                    <FontAwesomeIcon className='icon' icon={faStar}/>
                    {Number(item.avg_rate.toString().slice(0,3))}    
                </span>
            </li>
        )
        }):(<li className='order-item'>لا توجد تقييمات حتى الان </li>)
    return (
        <div className='statistics-panel panel-primary'>
            <div className="panel-heading">
                <h3>تقييم موظفي البوفية</h3>
                {check?(<button className='btn'  onClick={()=>setOrder(!order)}>
                    الترتيب 
                    <div className="panel-icon">
                        <FontAwesomeIcon className={order?'active':''} icon={faCaretUp}/>
                        <FontAwesomeIcon className={order?'':'active'} icon={faCaretDown}/>
                    </div>
                    
                </button>):(null)}
                
            </div>
            <ul>
                {order?getTopRated:getTopRated.reverse()}
            </ul>
            
           
            
        </div>
    )
}

